import { Experience } from 'services/api/entities/catalog/experience/types/internal/experience-models'
import { EntityDescriptor } from '.'
import { formatExperience } from './common'

export const virtuals: EntityDescriptor<Experience> = {
  format: formatExperience,
}
